import { Row, Button, Text } from '@cuemath/comps';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import ReactTable from 'react-table';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';

const TableWrapper = styled.div`
  width: 100%;
  max-height: calc(100vh - 20rem);
  overflow: auto;
`;

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  &:hover {
    color: blue;
  }
  &:active {
    color: blue;
  }
`;
const AssignButton = styled(Button)`
  height: 30px;
  padding-top: 3px;
`;

export default function TeacherMappingList(props) {
  const { defaultPageSize, query, onAssign } = props;
  const teacherMapping = useSelector(store => store.teacherMapping);
  const tableMapping = store.getAll(teacherMapping, query);
  const { data: tableDataArr } = tableMapping || {};
  const [tableData, setTableData] = useState([]);
  let pageSize = defaultPageSize || 20;

  useEffect(() => {
    if (tableMapping && tableMapping.__CODE__ === 400) {
      setTableData([]);
      alert('No Teacher found with given filters!');
    }
    tableDataArr && setTableData(tableDataArr);
  }, [tableDataArr, tableMapping]);

  const dataArray = data => {
    return data.map((value, idx) => {
      return <Text align="center">{data.length === idx + 1 ? value : `${value},`}</Text>;
    });
  };

  const tableColumns = [
    {
      columns: [
        {
          Header: 'Action',
          Cell: row => (
            <Row justifyContent="space-around">
              <AssignButton
                label="Assign"
                onClick={() => {
                  onAssign(row.original.id, row.original.name);
                }}
              />
            </Row>
          ),
        },
        {
          Header: 'Teacher Name',
          accessor: 'name',
          width: 200,
          Cell: row => {
            return (
              <Row justifyContent="space-around">
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/users/teachers/${row.original.id}`,
                  }}
                >
                  {row.original.name}
                </LinkNav>
              </Row>
            );
          },
        },
        {
          Header: 'Mobile',
          accessor: 'phone',
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'No. of Students Country Grade',
          width: 200,
          accessor: 'grade_country_students',
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'No. of Students Country Cohort',
          width: 200,
          accessor: 'country_students',
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'No. of Students Grade Cohort',
          width: 200,
          accessor: 'grade_students',
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'Native Cred',
          accessor: 'native_cred',
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'PAC to Paid',
          accessor: 'pac_to_paid',
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'Onboarded Date',
          accessor: 'onboarded_date',
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'City',
          accessor: 'city',
          style: { textAlign: 'center' },
          filterable: false,
          Cell: row => {
            const cities = row.original.city.split(',');

            return dataArray(cities);
          },
        },
        {
          Header: 'Bachelors Degree',
          accessor: 'bachelors_degree',
          width: 200,
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'Masters Degree',
          accessor: 'masters_degree',
          width: 200,
          style: { textAlign: 'center' },
          filterable: false,
        },
        {
          Header: 'Languages Known',
          accessor: 'languages',
          style: { textAlign: 'center' },
          Cell: row => {
            return dataArray(row.original.languages);
          },
          filterable: false,
        },
      ],
    },
  ];

  return (
    <React.Fragment>
      <TableWrapper>
        <ReactTable
          data={tableData}
          className="-striped -highlight"
          manual
          showPaginationTop
          showPageSizeOptions={false}
          filterable={false}
          sortable={false}
          resizable={false}
          defaultPageSize={pageSize}
          columns={tableColumns}
          defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
        />
      </TableWrapper>
    </React.Fragment>
  );
}
